/** Context-specific loading copy for CenteredPageLoader across list and detail views. */

export const ROUTE_LOADING_MESSAGES = {
  agentDashboard: "Loading dashboard…",
  homeDashboard: "Loading dashboard…",
  myLeads: "Loading Opportunities…",
  overview: "Loading Overview…",
  leadDetails: "Loading lead details…",
  configuration: "Loading configuration…",
  spocTasks: "Loading SPOC tasks…",
  spocTaskDetail: "Loading task details…",
  opportunityRedirect: "Loading opportunity…",
} as const;

export function getMyLeadsTabLoadingMessage(tab: string): string {
  switch (tab) {
    case "Daily To-do":
      return "Daily to-do list is populating";
    case "Today Contacted":
      return "Today contacted leads are populating";
    case "Past Due":
      return "Past due leads are populating";
    case "All":
    default:
      return "Leads are populating";
  }
}

export function getOverviewTabLoadingMessage(
  tab: "opportunities" | "patients" | "tasks"
): string {
  switch (tab) {
    case "opportunities":
      return "Opportunities are populating";
    case "patients":
      return "Patients are populating";
    case "tasks":
      return "Tasks are populating";
  }
}

export function getLeadDetailsMainLoadingMessage(
  isContactLead: boolean
): string {
  return isContactLead
    ? "Contact data is populating"
    : "Patient data is populating";
}

export type LeadDetailsTabLoaderKey =
  "Opportunities" | "Activities" | "Tasks" | "Documents" | "Orders";

export function getLeadDetailsTabLoadingMessage(
  tab: LeadDetailsTabLoaderKey
): string {
  switch (tab) {
    case "Opportunities":
      return "Opportunities are populating";
    case "Activities":
      return "Activities are populating";
    case "Tasks":
      return "Tasks are populating";
    case "Documents":
      return "Documents are populating";
    case "Orders":
      return "Orders are populating";
  }
}

export const NOTES_LOADING_MESSAGE = "Notes are populating";

export const SPOC_TASKS_LOADING_MESSAGE = "Tasks are populating";

export const SPOC_TASK_DETAIL_LOADING_MESSAGE = "Task details are populating";

/** Configuration admin section — list and detail loading copy */
export const CONFIG_LOADING_MESSAGES = {
  users: "Users are populating",
  permissionGroups: "Permission groups are populating",
  permissionGroup: "Permission group is populating",
  routingGroups: "Routing groups are populating",
  routingGroup: "Routing group is populating",
  teams: "Teams are populating",
  units: "Units are populating",
  departments: "Departments are populating",
  departmentsSearching: "Searching departments…",
  operationDepartments: "Operation departments are populating",
  doctors: "Doctors are populating",
  doctorsSearching: "Searching doctors…",
  doctor: "Doctor details are populating",
  services: "Services are populating",
  service: "Service details are populating",
  dispositions: "Dispositions are populating",
  tasksDispositions: "Tasks dispositions are populating",
  opportunityTypes: "Opportunity types are populating",
  stages: "Stage configs are populating",
  department: "Department details are populating",
  remarks: "Remarks are populating",
  broadcasts: "Broadcasts are populating",
  integrations: "Integrations are populating",
  webForms: "Web forms are populating",
  webForm: "Web form is populating",
  rnrDndAttempts: "Attempt settings are populating",
  googleAdsIntegration: "Integration details are populating",
  unitPocDispositions: "Unit POC dispositions are populating",
  unitPocAnalytics: "Unit POC analytics are populating",
  operationDepartmentMembers: "Department members are populating",
  outboundConnectivity: "Connectivity settings are populating",
  team: "Team details are populating",
  teamMembers: "Users are populating",
  fieldMappings: "Field mappings are populating",
  metaForms: "Forms are populating",
} as const;
